<template>
  <div class="col-lg-12 col-md-12 col-12">
    <div class="itemcard full">
      <div id="buy">
        <div id="slide1">
          <h2>YOU need ProxyScrape premium</h2>
          <router-link to="/premium?ref=fpl">
            <button class="btn">Find out why</button></router-link
          >
          <div>
            Or
            <a
              style="text-decoration: underline; cursor: pointer; padding: 15px 0 15px 0"
              class="loginbtn"
              onclick="dataLayer.push(
                {'event' : 'GAEvent', 'eventAction' : 'login', 'eventCategory' : 'haskey'}
                );"
              href="/login"
              >login</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
